import http from "@/settings/apiSettings"

class ProduseDataService {
    save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/PRO_Produse", data);
    }
    update(key: string, data: any): Promise<any> {
        return http.clientComercialOdata.patch(`/PRO_Produse(${key})`, data);
    }
    getParents(): Promise<any> {
        return http.clientComercialOdata.get("/PRO_Clase/with-parent");
    }
    cautaDupaCoduri(coduri: string[]): Promise<any> {
        return http.clientComercial.post("/PRO_Produse/cauta-coduri", coduri);
    }

}
export default new ProduseDataService();